<template>
  <div class="pt-2 pb-2">
    <div class="container-fluid">
      <div class="row">
        <div class="col offset-md-1 text-primary font-weight-bold mb-1">Browse by</div>
      </div>
      <div class="row">
        <div class="col offset-lg-1">
          <button class="btn btn-block btn-outline-primary alert-primary text-primary"
                  v-on:click="setGrouped(true, _.grouped,'name', 'order', 'asc')">
            <div class="d-flex">
              <icon :icon="['fad', 'layer-group']" class="fa-6x float-left"/>
              <h4 class="my-auto mx-auto"><span class="font-weight-bold">{{_.groupedCapital}}</span> <br>({{statistics.Grouped}}
                {{_.grouped}})</h4>
            </div>
          </button>
        </div>
        <div class="col">
          <button class="btn btn-block btn-outline-primary alert-primary text-primary"
                  v-on:click="setGrouped(true, 'authors','lastname', 'lastname', 'asc', true)">
            <div class="d-flex">
              <icon :icon="['fad', 'users']" class="fa-6x float-left"/>
              <h4 class="my-auto mx-auto"><span class="font-weight-bold">Authors</span> <br> ({{statistics.Author}}
                authors)</h4>
            </div>
          </button>
        </div>
        <div class="col">
          <button class="btn btn-block btn-outline-primary alert-primary text-primary"
                  v-on:click="setGrouped(false, 'titles','title', 'title', 'asc')">
            <div class="d-flex">
              <icon :icon="['fad', 'sort-alpha-down']" class="fa-6x float-left"/>
              <h4 class="my-auto mx-auto"><span class="font-weight-bold">Title</span><br> ({{statistics.Poster}} titles)
              </h4>
            </div>
          </button>
        </div>
        <div class="col-lg-1">&nbsp;</div>
      </div>
      <!--div class="row mt-4">
        <div class="col col-12 col-md-10 offset-md-1">
          <div class="text-primary font-weight-bold mb-1">Top 5 Posters</div>
          <ul class="list-group" v-if="ratingstop5.length">
            <router-link
              class="list-group-item list-group-item-action d-flex justify-content-between align-items-center border-primary"
              :to="'/viewer/' + toprating.abstract_id" v-for="toprating in ratingstop5">
              <span class="smaller-blank font-weight-bold">{{toprating.presentation_code}}: {{toprating.title}}</span>
              <div class="badge badge-primary badge-pill">{{toprating.ratings_avg}}</div>
            </router-link>
          </ul>
          <div class="alert-primary text-primary my-auto d-flex" v-else>
            <icon :icon="['fad', 'info']" class="ml-2 mt-2 mb-2 fa-3x"/>
            <div class="my-auto"> So far no presentations have been evaluated</div>
          </div>
          <span class="smaller float-right">min. 3 Ratings</span>
        </div>
      </div-->
    </div>
  </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        computed: mapState([
            'posters', 'mode', 'statistics', 'fullscreen', 'ratings', 'ratingstop5'
        ]),
        methods: {
            setMode(mode) {
                this.$store.state.mode.displayType = mode;
                this.$router.push('view');
            },
            setGrouped(grouped_status, mode_title, grouped_field = '', grouped_order = 'titSort', grouped_sort = 'asc', grouped_compact = false) {
                this.$store.state.loader = true;
                this.$store.state.openCollapse = 'group0';
                this.$store.state.mode.grouped.status = grouped_status;
                this.$store.state.mode.grouped.field = grouped_field;
                this.$store.state.mode.grouped.sort = grouped_sort;
                this.$store.state.mode.grouped.order = grouped_order;
                if (grouped_status === false) {
                    this.$store.state.mode.order = grouped_order;
                }
                this.$store.state.mode.title = mode_title;
                this.$store.state.mode.grouped.compact = grouped_compact;

                this.$store.state.posters = [];
                this.$store.dispatch('GET_ALL_RATINGS');
                this.$store.dispatch('GET_ALL_POSTERS', this.$store.state.mode);
                this.$router.push('view');
            }
        },
        created() {
            this.$store.dispatch('GET_TOP5_RATINGS');
            this.$store.state.fullscreen = false;
            this.$store.state.presentationSite = null;
        }
    }
</script>
